import { getContainers } from "helpers/services/container"
import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import { getContainersError, getContainersSuccess } from "./actions"
import { GET_CONTAINERS } from "./actionTypes"

function* getContainersOnSaga({ payload: { bookingNo } }) {
  try {
    const response = yield call(getContainers, bookingNo)
    if (response.success) {
      if (response.containers.data.length > 0)
        yield put(
          getContainersSuccess({
            containers: response.containers.data,
            type: response.containers.type
          })
        )
      else yield put(getContainersError("This booking not found !"))
    } else {
      yield put(getContainersError(response.message))
    }
  } catch (error) {
    yield put(getContainersError(error))
  }
}

function* ContainerSaga() {
  yield takeEvery(GET_CONTAINERS, getContainersOnSaga)
}

export default ContainerSaga
